import { Flex, Typography } from '@aloft/toolkit-sui';

import { DepreciationSegment } from '../../../../redux/constants.ts';
import {
  selectEcoLifeByIdAndField,
  selectSubjectiveCharacteristicsByIdAndField,
} from '../../../../redux/features/selectors/propertyDataSelectors/improvementsSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';

export const EffectiveAgeSeparateDepreciationTableRow = ({
  id,
  segment,
}: {
  id: string;
  segment: DepreciationSegment;
}) => {
  const effectiveAgeValue =
    useAppSelector((state: RootState) =>
      selectSubjectiveCharacteristicsByIdAndField(state, id, segment.effectiveAgeField),
    ) ?? 0;
  const totalEconomicLifeValue =
    useAppSelector((state: RootState) =>
      selectEcoLifeByIdAndField(state, id, segment.ecoLifeField, segment.defaultEcoLifeField),
    ) ?? 0;

  return (
    <Flex justifyContent="space-between">
      <Typography variant="body1">{segment.enabled ? (segment.label ?? '') : '-'}</Typography>
      <Typography variant="body1">
        {segment.enabled ? `E${effectiveAgeValue}/${totalEconomicLifeValue}` : '-'}
      </Typography>
    </Flex>
  );
};
